/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';
import classNames from 'classnames';
import React from 'react';
import SelectMenu from '#components/pages/Models/Model/sections/support/forms/SelectMenu/index.js';

type Props = {|
  form: string,
  name: string,
  responses: Array<{
    itemKey: string,
    name: string,
  }>,
|};

const DerivedFromSelectMenu = ({ form, name, responses }: Props): Element<typeof SelectMenu> => {
  const items = responses.map(response => {
    const { itemKey, name: responseName } = response;
    return {
      id: itemKey,
      name: responseName,
      value: itemKey,
    };
  });

  return (
    <SelectMenu
      form={form}
      items={items}
      id={name}
      name={name}
      inputClassName={classNames('custom-select', 'derivedFrom-select')}
      includeEmptyOption
    />
  );
};

export default DerivedFromSelectMenu;
